import UsersTable from '../components/UsersTable';

export default function UsersPage() {
  return (
    <div>
      <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">
        Users
      </h2>
      <p className="mt-2 text-sm text-gray-500">Manage Vaava users</p>
      <div className="mt-6 bg-white shadow rounded-lg overflow-hidden">
        <UsersTable />
      </div>
    </div>
  );
}
